import $ from 'jquery';
import {__orbit,WTGFIXEDLINE} from './orbitUtil';
import {TR} from 'h2g-test-results/js/test-results';
import LINEARVIEW from 'h2g-linear-view/js/linearview';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';
import TRACEROUTE from 'traceroute/js/traceroute';
import H2GRESULTS from 'h2g-test-results/js/test-results';
import {inputDialog} from 'h2g-test-results/js/util';
import {speed_test} from 'speed-test/js/speedTest';
import toastr from 'toastr';
import ROUTERCONFIG from 'router-config/htdocs/js/wifi-configuration';
import * as intl from 'wtg/intl';
import TODO from '../TODO';

angular.module("SupportAgent")
.controller(
 'MainCtrl',
 function(
  $rootScope, $scope, EventHandler,
  $location, $filter, $timeout, $q,
  ngTableParams, $routeParams, gettextCatalog, $mdDialog, $mdMedia,
  C11N, L, INTERACT, INTRACTABLE, U, SPEEDTESTDATA, tracerouteData, PERSISTENCE, IDA) {
  H2GDIALOG.mdDialog = $mdDialog;
  var wtgcp = (typeof WTGCONFIG !== 'undefined')?WTGCONFIG:{};
  var known_languages = {
   /* TODO: this is an example of sheer stupidity, especially when put into a table,
      we can't maintain any kind of consistency in where we use country name, where
      we use language name, where we use English name and where local name. Besides,
      some of these strings should be translatable. */
   English: { code:'en', flag:'united-kingdom', flagname: 'English', name: 'English' },
   French: { code: 'fr', flag:'france',  flagname: 'France', name: 'Français' },
   Deutsch: { code: 'de', flag: 'germany', flagname: 'Germany', name: 'Deutsch' },
   Italiano: { code: 'it', flag: 'italy', flagname: 'Italy', name: 'Italiano' },
   Spain: { code: 'es', flag: 'spain', flagname: 'Spain', name: 'Español' },
   Russian: { code: 'ru', flag: 'russian', flagname: 'Russian', name: 'Russian' },
   Latvian: { code: 'lv', flag: 'latvian', flagname: 'Latvian', name: 'Latvian' }
  };
  $rootScope.production = wtgcp.production;
  $rootScope.brand_name = wtgcp.brand_name;
  C11N.brand=(wtgcp.brand_name=='Webtogo')?'h2g':wtgcp.brand_name;
  WTG.circular_view=(C11N.brand!="baltcom");
  $rootScope.brand_icon = "img/"+wtgcp.brand_icon;
  $rootScope.default_brand_logo = "img/"+wtgcp.brand_logo;
  $rootScope.brand_color = wtgcp.brand_color;
  $rootScope.notification_icon = "img/"+wtgcp.notification_icon;
  $rootScope.favicon_16 = "img/"+wtgcp.brand_name+"-favicon-16x16.png";
  $rootScope.favicon_32 = "img/"+wtgcp.brand_name+"-favicon-32x32.png";
  $rootScope.languages = wtgcp.language_list&&wtgcp.language_list.map(function(x) {
   return known_languages[x];
  }).filter(function(x){return x && intl.have_language(x.code)});
  $rootScope.circle_theme = wtgcp.circle_theme||"";
  var supported_tests = [];
  var supported_groups = [];
  var overview_tests_list = [];
  var excepted_expired_tests={};// The tests which are excepted to show them even they expired
  $rootScope.all_tests = [];
  $rootScope.all_groups = [];
  $rootScope.page_title = wtgcp.page_title;
  $rootScope.profile = {};
  $rootScope.conversationID = undefined; // Current Conversation ID
  $rootScope.btnVideoCallDisable = false;
  // TODO: this should be handled on the presentation level
  $rootScope.tests = [{"test_name":"Loading..."}];
  $rootScope.selectedTest = $rootScope.tests[0];
  // TODO: this should be handled on the presentation level
  $rootScope.testGroups = [{"id":1,"test_group_name":"Loading..."}];
  $rootScope.selectedGroup = $rootScope.testGroups[0];
  $rootScope.filteredTestList = [];
  $rootScope.evaluations = {};
  $rootScope.resultGroups = [];
  $rootScope.fullResults = [];
  $rootScope.tableParams; // TODO: `$rootScope.tableParams` what?
  $rootScope.is_audio_call_accepted = false;
  $rootScope.data_analytics_url = wtgcp.data_analytics;
  // TODO:general brand-based craziness
  $rootScope.conversationStatus = (
   ($rootScope.brand_name!='tiGo')?[
    "str_conv_status_pending", "str_conv_status_ongoing",
    '','', "str_conv_status_interrupted", "str_conv_status_closed"
   ]:[
    "str_conv_status_pending", "str_conv_status_ongoing",
    '','', "str_conv_status_not_solved", "str_conv_status_solved"
   ]
  ).reduce(function(p,c,i) { if(c)p[i]=c; return p },{});
  $rootScope.chartChoice = 'sessions';
  $rootScope.appsList = [];
  $rootScope.remoteConnection = { acid: 0, did: 0, cid: 0, connected: false };
  $rootScope.virtualConnection = {};
  var selDevIndex = 0;
  $rootScope.SecurityTests = [];
  $rootScope.deviceInfo = { /* TODO: this seems to belong to `tab-device` */
   battery: {capacity:"", temperature:""}, usage: { cpu:"", ram:""},
   memory: {internal: { spaceinPercentage:"",freeSpace:"",totalSpace:""},
           external:{ spaceinPercentage:"",freeSpace:"",totalSpace:""}},
   mobile: {operator:"", technology:""},
   wifi: {ssid: "", signal:""}
  };
  $rootScope.securityPolicies = {
   unknownSources:"false",
   appVerfication:"false",
   visiblePassword:"false",
   mdmEnabled:"false"};
  $rootScope.testPayload = {
   deviceInfo:"1|82|1||1|83|1||1|74|1||1|72|1||1|75|1||1|76|1||1|124|1||1|79|1||1|11|1||1|71|1||1|142|1||",
   policiesInfo:"3|126|1||3|127|1||3|128|1||",
   installApp:"2|123|1|Install,",
   uninstallApp:"2|123|1|Uninstall,"};
  $rootScope.mdmGroups = [
   "UserRelated",
   "Security",
   "MDM",
   "Android"];
  $rootScope.mdmUserRelated = [
   "user.first_name",
   "user.last_name",
   "user.display_name",
   "user.user_id",
   "user.email_address"];
  $rootScope.mdmSecurity = [
   "common.device_encrypted",
   "android.secure_apps_encryption_enabled",
   "common.security_state",
   "common.sd_card_encrypted",
   "android.security_detail",
   "android.secure_apps_enabled",
   "android.secure_apps_encryption_mode",
   "common.device_is_compromised"];
  $rootScope.MDM = [
   "android.admin_activated",
   "common.mdm_managed",
   "common.creation_date",
   "common.registration_date",
   "common.last_connected_at",
   "common.registration_uuid",
   "android.mdm_enabled",
   "android.registration_status",
   "common.client_version",
   "android.Client_version_code",
   "common.client_name",
   "android.multi_mdm",
   "common.device_admin_enabled",
   "common.mdm_tos_accepted",
   "common.mdm_tos_accepted_date"];
  $rootScope.mdmAndroid = [
   "android.kiosk_enabled",
   "android.gcmToken",
   "android.c2dmToken",
   "android.knox_version",
   "common.apns_capable",
   "android.afw_capable"];
  $rootScope.orbitX = new __orbit();
  $rootScope.wtg_fixedline = new WTGFIXEDLINE();
  $rootScope.videoCallImages = {
   "mic_mute_icon": "img/ic_mic_mute.svg",
   "mic_un_mute_icon": "img/ic_mic_un_mute.svg",
   "camera_mute_icon": "img/ic_camera_mute.svg",
   "camera_un_mute_icon": "img/ic_camera_un_mute.svg",
   "video_front_camera_icon": "img/ic_front_camera.svg",
   "video_rear_camera_icon": "img/ic_rear_camera.svg",
   "connect_phone_icon": "img/ic_call_black.svg",
   "disconnect_phone_icon": "img/ic_phone.svg",
   "overlay_maximize_icon":"img/maximize.png"
  };
  var overview_tests = [];
  $rootScope.mic_icon = $rootScope.videoCallImages.mic_mute_icon;
  $rootScope.video_icon = $rootScope.videoCallImages.camera_un_mute_icon;
  $rootScope.camera_icon = $rootScope.videoCallImages.video_front_camera_icon;
  $rootScope.phone_icon = $rootScope.videoCallImages.connect_phone_icon;
  $rootScope.deviceImages = {
   "Samsung": {
    "SM-G900F": "img/novnc/SM-G900F.png",
    "SM-G935F": "img/novnc/SM-G935F.png",
    "GT-I9070": "img/novnc/SM-G900F.png",
    "GT-I9300": "img/novnc/GT-I9300.png",
    "SM-J200G": "img/novnc/SM-G900F.png",
    "SM-N910G": "img/novnc/SM-G900F.png",
    "SM-J320FN": "img/novnc/SM-J320FN.png",
    "GT-I9305": "img/novnc/GT-I9300.png"
   },
   "Huawei": {
    "ALE-L21": "img/novnc/ALE-L21.png",
    "Che1-L04": "img/novnc/ALE-L21.png"
   },
   "LeTV": {
    "Le X526" : "img/novnc/Le X526.png"
   },
   "default": {
    "default": "img/novnc/nexus5x.png"
   }
  };
  $rootScope.remote_error_message = "";
  $rootScope.support_tabs_loaded = false;
  $rootScope.is_in_video_call=false;
  $rootScope.is_incoming_alert_on=false;
  $rootScope.terminalAccessPermissions = [];
  $rootScope.tabsLoaded = false;
  $rootScope.preConversationID=0;
  $rootScope.submit_results = [{"id":INTERACT.D.xaction.live_diagnostics_states.query,"str_id":"str_submission_flag_query"},
  {"id":INTERACT.D.xaction.live_diagnostics_states.on,"str_id":"str_diagnostic_results_on"},{"id":INTERACT.D.xaction.live_diagnostics_states.off,"str_id":"str_diagnostic_results_off"}];
  $rootScope.session_status={ongoing:1,logout:2,lost_connection:3,terminated:4};
  $rootScope.callDetails = {};
  $rootScope.speed_test_type= {
    wifi_speed:"p2p",   // Test within local network (measuring wifi performance)
    provider_speed:"line", // Test from router to some server on the internet (measuring provider performance)
    total_speed:"e2e",    // Test from device to outside (measuring everything end-to-end)
    wifi_router_speed:"wifi" // Test from device to router
  };
  $rootScope.traceroute_servers = ["google.com"];
  var webpush_supported=false;
  $rootScope.is_dynamic_domain_portal=!!(WTGCONFIG.domain===undefined);
  var is_auto_diagnostics_off=false;
  $rootScope.user_access={};
  $scope.logout = function () {
   //EventHandler.setLoggedIn(false);
   EventHandler.APILAYER.logout();
   $rootScope.unpersist_login();
   window.location.reload();
  };
  $rootScope.isConversationOfCurrentAccount = function (conversation) {
   return (conversation.p)?conversation.p.some(function(x){return $routeParams.aid==x.id}):false;
  };
  $rootScope.ISO8601DateFormat = function (ISODate) {
   var tempISODate = new Date(ISODate);
   return pad(tempISODate.getHours()) + ":" +
    pad(tempISODate.getMinutes()) + " " +
    pad(tempISODate.getDate()) + "." +
    pad((tempISODate.getMonth() + 1)) + "." +
    pad(tempISODate.getFullYear());
  };
  function pad(n) { return n < 10 ? '0' + n : n }
  function applyResults(account, sd, results) {
   prepareGroups(results);
   $timeout(
    function() {
     if(results!="") {
      $rootScope.securityPolicies = {};
      $rootScope.checkAndRunSecurityInfoTests(results,false);
     }
     $rootScope.$broadcast("updateDeviceTabData",results);
     $rootScope.$applyAsync(function(){});
    }, 0);
   $rootScope.tableParams = new ngTableParams(
    {
     page: 1, // show first page
     count: 100, // count per page
     sortable: {
      ts: 'asc'
     }
    },
    {
     groupBy: 'group_name',
     total: $rootScope.resultGroupsCount,
     getData: function ($defer, params) {
      //TODO: check out the custom comparator to $filter('orderBy')() call
      var oby = params.sorting() && $rootScope.tableParams.orderBy().shift();
      var obysign = (oby && oby[0])!='-';
      var obyp = oby && oby.substr(1);
      var orderedData = $rootScope.resultGroups.filter(function (result) { return result.display });
      orderedData.sort(function(x,y){
       if(x.group_id!=y.group_id) {
        if(x.group_id==26) return -1;
        if(y.group_id==26) return 1;
       }
       else if(obyp) {
        if(!obysign) {
         var z = x; x = y; y = z;
        }
        return (''+x[obyp]).localeCompare(''+y[obyp]);
       }
       return x.group_name.localeCompare(y.group_name);
      });
      $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page()*params.count()));
      params.total(orderedData.length);
     }
    });
  }
  $rootScope.selectDevice = function (sd) {
   $('#profileLoadingicon').show();
   selDevIndex = sd;
   $rootScope.pendingRes = [];
   var acid = +$routeParams.aid;
   var account = INTERACT.get_account(acid);
   account.sd = sd;
   $rootScope.resultGroups = [];
   $rootScope.fullResults = [];
   if(!$rootScope.isHidden("circle")) {
    /*to stop circle updation flow with previous device.*/
    if($rootScope.deviceID&&$rootScope.deviceID!=account.d[sd].id) {
      EventHandler.stopLiveDataConnection($rootScope.preConversationID);
    }
    $rootScope.preConversationID = $rootScope.conversationID;
    $rootScope.enableUserSettingsBtn = false;
    $rootScope.bWifiProvider=false;
    $rootScope.settings_alerts = [];
    if(!$rootScope.isHidden("h2g-linear-view")) {
     $timeout(function() {
      LINEARVIEW.controller($scope ,$rootScope,$rootScope.onClickLinearViewOrbit);
     },500);
    }
   }
   $rootScope.deviceID = account.d[sd].id;
   C11N.is_ios=(account.d[sd].type==INTERACT.D.client.type.ios);
   updateDeviceStatus($rootScope.deviceID,acid);
   $rootScope.imagePath = $rootScope.deviceImages.default.default;
   $rootScope.imei = account.d[sd].imei;
   $rootScope.tabsLoaded = true;
   $rootScope.enableLiveResultsControl = false;
   changeSupportView(account.d[sd].product_id);
   if($rootScope.support_tabs_loaded) $rootScope.setDefaultTab();
   loadTestGroups();
   $rootScope.showTestStatusTable = false;
   updateOrbitCircle({});
   $rootScope.current_circle_group = "";
   $rootScope.orbitX.setStatus("","",$rootScope.strings.str_device_offline);
   $rootScope.showAwakeButton = false;
   $rootScope.showProviderInfo=false;
   $rootScope.is_call_with_other_ticket=false;
   $rootScope.speedtest_capabilities={"e2e":{"dl":true,"ul":true,"status":1}};
   $('#btn_wakeupDevice').button('reset');
   if(acid && $rootScope.deviceID)
    updateDeviceOnlineStatus(acid,$rootScope.deviceID);
   else
    L.error({acid:acid,devid:$rootScope.deviceID},"refusing to update online status of undefined device");
   var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.did==$rootScope.deviceID});
   $rootScope.terminalAccessed= tap?tap.grant:true;
   $rootScope.disable_send_btn = tap&&tap.btn_disable;
   if(!$rootScope.isHidden('terminal')) $rootScope.onChangeMessageType($rootScope.messageTypes[0]);
   if($rootScope.remoteImages) {
    $timeout(
     function() {
      $rootScope.$broadcast("onUpdateImageGallery",$rootScope.remoteImages,account.d[account.sd].id);
      $rootScope.$broadcast("onUpdateScreenshotImageGallery",$rootScope.remoteImages,account.d[account.sd].id);
     }, 0);
   }
   applyResults(account, sd, []);
   if($rootScope.is_audio_call_accepted&&Object.keys($rootScope.callDetails).length!=0) {
    if(!$rootScope.callDetails.is_overlay_closed) $('#videocall-modal').fadeIn();
    if($rootScope.callDetails.conversationID&&$rootScope.callDetails.conversationID!=$rootScope.conversationID)
     $rootScope.is_call_with_other_ticket=true;
   }
   if(!$rootScope.isHidden("circle")) {
    var devimages = $rootScope.deviceImages;
    if(account.d[sd].man) {
     var images = devimages[account.d[sd].man]||devimages.default;
     if(images) $rootScope.imagePath = images[account.d[sd].model]||devimages.default.default;
    }
   }
   if($rootScope.isDeviceOnline()) sendInitialRequests(); // send only when device in online
   $rootScope.$applyAsync(function(){});
   var tr = account.tr[sd];
   if(tr) {
    applyResults(account, sd, tr.results);
    //if(account.ts[sd]) updateOrbitCircle(account.ts[sd]);
   }
   else if(account.d[sd] && account.d[sd].id) {
    $rootScope.pendingRes.push("results");
    INTRACTABLE.request("test/results",
     {"DID": account.d[sd].id,
      'S':'-rid',
      'T':1,
      'L':10
     },
     function(e, r) {
      $rootScope.pendingRes.splice($rootScope.pendingRes.indexOf("results"),1);
      if(!$rootScope.pendingRes.length) $('#profileLoadingicon').hide();
      if(e) return L.warn({e:e},"error fetching test results");
      if(r._S!='ok') return L.warn({r:r},"error fetching test results");
      account.tr[sd] = { total: r.total, results: r.results };
      applyResults(account, sd, r.results);
      if(Object.keys($rootScope.fullResults).length != 0)
       $rootScope.lastTestResultDate = $rootScope.ISO8601DateFormat($rootScope.fullResults[0].ts);
      $rootScope.retrievedTransactions({convid:$rootScope.conversationID});
      $rootScope.$applyAsync(function(){});
     });
   }
   //apps/get
   $rootScope.pendingRes.push("apps");
   INTRACTABLE.request("apps/get",
    { "DID": account.d[sd].id },
    function (e, r) {
     $timeout(function () {
      $rootScope.appsList = ((!e) && (r._S == 'ok')) ? r.apps : {};
      $rootScope.pendingRes.splice($rootScope.pendingRes.indexOf("apps"),1);
      if(!$rootScope.pendingRes.length) $('#profileLoadingicon').hide();
      $rootScope.$applyAsync(function(){});
      $('.footable').footable(); //Initialize FooTable!
      $('.footable').data('footable').reset(); //reset data
     }, 100);
    });
   if($rootScope.imei) $rootScope.fetchMDMdetails();
   else $rootScope.mdmEnabled = false;
   $rootScope.loadSpeedTestScreen=false;
  };
  var amthPromise = null;
  /* { // XXX: this documentation is produced by someone who has no clue
   *  convid:           // conversation id
   *  acid:             // account id I would expect
   *  msg:              // likely the message
   *  msgtime:          // likely the message time, previously aptly named `t`
   *  channelid:        // channel id, I presume
   *  msgid:            // the id of the message one would have guessed
   *  convtime:         // the timestamp of the conversation, I believe
   * } */
  $rootScope.appendMessageToHistory = function(bundle) {
   var accid = bundle.acid||undefined;
   if(bundle.display_name) L.warn({bundle:bundle},"display_name is supplied to appendMessageToHistory");
   var msg = bundle.msg||undefined;
   var t = bundle.msgtime||undefined;
   var chid = bundle.channelid||undefined;
   if(bundle.convstatus) L.warn({bundle:bundle},"conv_status is supplied to appendMessageToHistory");
   if(bundle.is_wait_member) L.warn({bundle:bundle},"is_wait_member is supplied to appendMessageToHistory");
   if(bundle.first_name) L.warn({bundle:bundle},"first_name is supplied to appendMessageToHistory");
   if(bundle.last_name) L.warn({bundle:bundle},"last_name is supplied to appendMessageToHistory");
   var msgid = bundle.msgid||undefined;
   if(bundle.conv_ts) L.warn({bundle:bundle},"conv_ts is supplied to appendMessageToHistory");
   var conid = bundle.convid||undefined;

   var convo = INTERACT.get_conversation(+conid);
   if(!convo) return L.error({bundle:bundle},"appendMessageToHistory of unknown conversation");
   if(msg=="") return L.error({bundle:bundle},"appendMessageToHistory with no message to speak of");
   if(conid == $rootScope.conversationID)
    convo.msg_count = 0;
   else
    ++convo.msg_count;
   convo.add_message({
    t: t,
    accid: accid,
    ch: chid,
    msg: msg,
    mid: msgid
   });
   // TODO: this is pretty ugly attempt on debounce and in general this `$apply()` shouldn't be needed.
   if(amthPromise) $timeout.cancel(amthPromise);
   amthPromise = $timeout(function() { $rootScope.$apply() }, 1000);
  };

  $scope.isSupport = function (item) {
   return (item.conversations[0].status === "Open");
  };
  $rootScope.isDiagTestReady = function(conid) {
   if(!$rootScope.conversation_is_mine) return false;
   // TODO: `acid` is a bad name for the actual account, not its id
   var acid = INTERACT.get_account($rootScope.accountID);
   var convo = INTERACT.get_conversation(+conid);
   // TODO: The comparison below is criminal, no one should ever compare to
   // display strings, it could, after all coincide with *anything*.
   return !!(convo && acid && acid.dcid && acid.d && acid.d.length && acid.d[0].name!=$rootScope.strings.str_not_found && convo.status <= 1);
  };
  $scope.isEnable = function(conid) {
   if(!INTERACT.get_account($rootScope.accountID)) return false;
   var convo = INTERACT.get_conversation(+conid);
   return !!(convo && convo.status <= INTERACT.D.conversation.status.ongoing);
  };
  $scope.get12HourTime = function(date, full) {
   var hours = date.getHours();
   var d = ("0" + date.getDate()).slice(-2) + "." + ("0" + date.getMonth()).slice(-2) + "." + date.getFullYear() + " ";
   return (full?d:"") + (((hours>12)?(hours-12):hours) + ":" + ("0" + date.getMinutes()).slice(-2)) + " " + (date.getHours()>11?"PM":"AM");
  };
  // { convid: }
  $rootScope.retrievedTransactions = function(input,cb) {
   var convo = INTERACT.get_conversation(+input.convid);
   var limit = 60;
   if(!convo) {
    L.warn({input:input},"retrieving transactions for inexistent conversation");
    if(cb) cb(new Error("retrieving transactions for inexistent conversation"));
    return;
   }
   if(!convo.timeline) convo.timeline = {};
   if(!convo.timeline.offset && !convo.timeline.retrieved) {
    // TODO: interestingly enough the condition above is triggered when offset
    // is zero and retrieved is false :)
    convo.timeline.offset = 0;
    convo.timeline.retrieved = false;
   }
   if(convo.timeline.retrieved) {
    if(cb) cb(null,{count:0});
    return;
   }
   INTRACTABLE.request("conversation/transactions",
    {"CID": +convo.id,
     "O":  convo.timeline.offset,
     "L": limit},
    function(e, r) {
     if(e) {
      WTG.REPORT.exception(e);
      if(cb) cb(e);
      return;
     }
     if(r._S=='nodata') {
      r.transactions=[];
      convo.timeline.retrieved=true;
      if(cb) cb(null,{count:0});
      return;
     }
     else if(r._S!='ok') {
      WTG.REPORT.message("can't get conversation transactions",{r:r});
      if(cb) cb(new Error("can't get conversation transactions"));
      return;
     }
     $("transactionsContainer").html = "";
     if(!(r.transactions && r.transactions.length)) {
      convo.timeline.retrieved = true;
      if(cb) cb(null,{count:0});
      return;
     }
     var message = "";
     for(var i=0;i<r.transactions.length;i++) {
      var transaction = r.transactions[i]; // "this" transaction
      if(transaction.channel_id==INTERACT.D.xaction.channel.remote) continue;
      if(convo.m.some(function(x){return x.mid==transaction.transaction_id}))
       continue;
      if(transaction.channel_id == INTERACT.D.xaction.channel.diagreq) {
       if(transaction.content.startsWith("6|status|") || transaction.content.startsWith("6|publicIP")) continue;
       var result = transaction.content.split('|');
       var rt = +result[0];
       if(rt==8 || rt==10) continue;
       if(rt==7 && result[1]=='command') {
        message = prepareTerminalMessage(transaction.content);
       }else{
        var thetest;
        if(rt==2) { //diagnostic fix request
         thetest = $rootScope.tests.find(function(x){return x.test_id==+result[1]});
         if(!thetest) continue;
         message  = $rootScope.strings.Diagnostic_fix_request + thetest.test_name;
        }else if(rt==1 || result.length==3){ //diagnostic test request
         thetest = $rootScope.tests.find(function(x){return x.test_id==+result[1]});
         if(!thetest) continue;
         message  = $rootScope.strings.str_diagnostic_request + thetest.test_name;
        }else {
         if(result[1].startsWith('group')) { //diagnostic group request
          var gid = +result[1].substring(5);
          var thegroup = $rootScope.testGroups.find(function(x){return x.group_id==gid});
          if(!thegroup) continue;
          message  = $rootScope.strings.str_diagnostic_request + thegroup.test_group_name;
         }else if(transaction.content.length > 10) {
          message  = $rootScope.strings.str_diagnostic_request;
          if(transaction.content == $rootScope.testPayload.deviceInfo) message+= $rootScope.strings.DeviceInfo;
          else if(transaction.content == $rootScope.testPayload.policiesInfo) message+= $rootScope.strings.str_security_policies;
          else if(transaction.content.startsWith($rootScope.testPayload.installApp)) message+= $rootScope.strings.installApp;
          else if(transaction.content.startsWith($rootScope.testPayload.uninstallApp)) message+= $rootScope.strings.uninstallApp;
         }else message = $rootScope.strings.str_diagnostic_request + { // TODO: lotsa magic and insanity and performance impact
           1:$rootScope.strings.str_locate_device, 2:$rootScope.strings.str_play_alert, 3:$rootScope.strings.str_lock_device,
           5:$rootScope.strings.str_wipe_device, 6:$rootScope.strings.str_silent_picture, 7:$rootScope.strings.RemoteScreenshot
          }[result[1]]; //security test
        }
       }// not command
      }else if(transaction.channel_id == INTERACT.D.xaction.channel.diagres) {
       if(transaction.content.startsWith('command|')) {
        message = prepareTerminalMessage(transaction.content);
       }else if(transaction.content.startsWith('submission|')) {
        message = prepareSubmitResultEventMessage(transaction.content);
       }else if(transaction.content.startsWith('6|publicIP')) continue;
       else {
        message = prepareTestResultMessage(transaction);
        if(message=="-") continue;
       }
      }else if(transaction.channel_id == INTERACT.D.xaction.channel.videochat) {
       if(transaction.content) {
        var jobj=JSON.parse(transaction.content);
        if(jobj) {
         var pf = INTERACT.get_account($rootScope.accountID).get_profile();
         var un=pf?(pf.first_name||pf.last_name||"User"):"User"; // TODO: looks like a copypaste marked "1553980282" in support-chat
         if(jobj.type=="video-close"){
          $rootScope.callDetails.bcallEnd = true;
          $rootScope.callDetails.endTime = transaction.timestamp;
          continue;
         }
         if(jobj.type=="video-response"&&jobj.accept==true){
           $rootScope.callDetails.bcallStart = true;
           $rootScope.callDetails.callby = jobj.to;
           $rootScope.callDetails.startTime = transaction.timestamp;
         }
         if($rootScope.callDetails.bcallStart && $rootScope.callDetails.bcallEnd) {
          var duration = $rootScope.prepareCallDuration($rootScope.callDetails.startTime, $rootScope.callDetails.endTime, $rootScope.callDetails.callby);
          message = duration;
          $rootScope.callDetails = {};
         }else {
          message={"on-offer":"","on-answer":"","video-request":$rootScope.strings.str_support_requested_call,"on-ice":"","media-change":""}[jobj.type];
          if(jobj.type=="video-response"&&jobj.accept==false) message= WTG.fmt($rootScope.strings.str_user_call_rejected,{un:un});
         }
        }//jobj
        if(message=="") continue;
       }//translaction.content
      }else message = transaction.content; //normal message
      $rootScope.appendMessageToHistory({
       convid: convo.id, acid: transaction.user_id,
       msg: message,
       msgtime: U.time.from_unix_epoch(transaction.timestamp),
       channelid: transaction.channel_id,
       msgid: transaction.transaction_id
      });
     }//transaction loop
     if(r.transactions.length==limit) $('#load_more_transactions_status').css('display','block');
     convo.timeline.offset += r.transactions.length;
     var m = convo.m.sort(function (a, b) { return a.t-b.t });
     if(m[m.length-1]) convo.lm = m[m.length-1].t;
     if(cb) cb(null,{count:r.transactions.length});
    }
   );
  };

  /* TODO: these should be on a per-device basis and aren't cleared on switches
   * or whatever, like it usually is the case with global state */
  var getjsonry = {
   nextid: 0,
   ids: {},
   get_json: function(table,cb) {
    table = encodeURIComponent(table);
    var that = this;
    var gjid = this.nextid++;
    var gj = this.ids[gjid] = {
     cb: cb,
     when: new Date(),
     data: [],
     lastindex: 0,
     timeout: $timeout(function() {
      $timeout.cancel(gj.timeout);
      delete that.ids[gjid];
      gj.cb(new Error("failed to get json in time"));
     },10000) // TODO: unhardcode, perhaps? 
    };
    EventHandler.APILAYER.sendMessage({
     convid:$rootScope.conversationID, channelid:INTERACT.D.xaction.channel.diagreq,
     msg: '6|getjson|'+JSON.stringify({table:table,cbid:gjid}), // TODO: magic
     devid: $rootScope.deviceID
    });
   },
   put_json: function(sc,extra) {
    var pipeidx = sc.indexOf('|');
    if(pipeidx<0) return L.error({message:extra.message},"probably corrupt message, ceci n'est pas une pipe");
    var resHeader = JSON.parse(sc.substring(0,pipeidx));
    var gjid = resHeader.cbid;
    var gj = this.ids[gjid];
    if(!gj) return L.error({known_ids:Object.keys(this.ids),message:extra.message},
                           "response to not quite known request");
    var dt = +new Date() - +gj.when;
    L.trace({message:extra.message,dt:dt},"invoking get_json callback");
    var hasindex = resHeader.hasOwnProperty('index');
    if( hasindex && gj.lastindex!=(resHeader.index-1))
     L.error({message:extra.message,gjdata:gj.data,lastindex:gj.lastindex},
             "getjson response out of sequence");
    gj.data.push(sc.substring(pipeidx+1));
    if(resHeader.index>=resHeader.count || !hasindex) {
     $timeout.cancel(gj.timeout);
     delete this.ids[gjid];
     var rv = gj.data.join('');
     if(!rv) return gj.cb(new Error('getjson received no data'));
     try {
      rv = JSON.parse(rv);
     }catch(e) { return gj.cb(e) }
     gj.cb(null,rv);
    }
   }
  };
  $rootScope.get_json = getjsonry.get_json.bind(getjsonry);

  /** TODO: do something about leaking in the above and below */

  // TODO: this, like the one above, should also be handled on a per-device basis
  /** TODO: TODO: TODO: This turns out to be a stub for future development.
   * It can't possibly get the properly identified by callback data from the app
   * and it is the next step (hopefully very next step) to come up with some
   * non-breaking mechanism. */
  var statusery = {
   nextid: 1,
   influx: {}, // {id:{cb:,when:,data:[],lastindex}}
   get_status: function(bundle,cb) {
    if(!bundle) bundle = {};
    var cbid = this.nextid++;
    // TODO: the below should only happen in legacy mode (and better not)
    if(this.influx[cbid]) L.warn({bundle},"already have status update in progress");
    this.influx[cbid] = {
     cb: cb||this.fallback_callback, // TODO: the fallback must be temporary
     when: new Date(), // TODO: eventually implement timeouts
     data: [],
     lastindex: 0
    };
    EventHandler.APILAYER.sendMessage({
     convid: bundle.convid||+$rootScope.conversationID,
     channelid: INTERACT.D.xaction.channel.diagreq,
     // TODO: magic, INTERACT.D.xaction.payload.status
     msg: '6|status|,|,|'+JSON.stringify({cbid:cbid}),
     devid: bundle.devid||+$rootScope.deviceID
    });
   },
   feed_in: function(sc,extra) {
    var pipeidx = sc.indexOf('|');
    if(pipeidx<0) return L.error({message:extra.message},"probably corrupt message, ceci n'est pas une pipe");
    var h = JSON.parse(sc.substring(0,pipeidx));
    var cbid = h.cbid||0; // TODO: `0` is a legacy callbackless more
    var s = this.influx[cbid]||(h.index==1 && (this.influx[cbid]={ // TODO: this is hopefully temporary
     cb: this.fallback_callback,
     when: new Date(),
     data: [],
     lastindex: 0
    }));
    if(s.lastindex!=(h.index-1)) {
     delete this.influx[cbid];
     return L.error({message:extra.message,s:s,cbid:cbid},"status chunk out of sync");
    }
    s.data.push(sc.substring(pipeidx+1));
    if(h.index!=h.count) return;
    delete this.influx[cbid];
    var rv = s.data.join('');
    if(!rv) return s.cb();
    try {
     rv = JSON.parse(rv);
    }catch(e) { return s.cb(e) }
    s.cb(null,rv);
   },
   fallback_callback: function(e,r) {
    if(e) return L.error({err:r},"error retrieving status");
    if(r && Object.keys(r).length) {
     // now circle status response contains additional information {alerts:{},
     // results:{}}
     // old response also handled
     var results=r.results||r;
     filter_expired_results(results);
     updateOrbitCircle(results);
     submitBulkResults(results);
     $rootScope.enableUserSettingsBtn = !!r.alerts;
     $rootScope.settings_alerts = r.alerts||[];
     is_auto_diagnostics_off=false;
     if(r.hasOwnProperty("auto_diagnostics")&& !r.auto_diagnostics) {
      is_auto_diagnostics_off=true;
      if(!$rootScope.isHidden("h2g-linear-view")) $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_auto_diagnostics_off);
      else $rootScope.orbitX.setStatus("","",$rootScope.strings.str_auto_diagnostics_off);
     }
     if($rootScope.current_circle_group!=""&&$rootScope.current_circle_group!="errors") $rootScope.updateStatusTable($rootScope.current_circle_group);
     $('#circlerefreshicon').removeClass('fa-spin');
    } else {
     updateOrbitCircle({});
     if(!$rootScope.isHidden("h2g-linear-view")) $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_no_test_results);
     else $rootScope.orbitX.setStatus("","",$rootScope.strings.str_no_test_results);
    }
    EventHandler.APILAYER.sendMessage({
     convid: +$rootScope.conversationID, // TODO: it's best to use the one used
                                         // to send the request
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg:"6|status|OK", // TODO: magic
     devid: $rootScope.deviceID // TODO: it's best to use the one used to send
                                // the request
    });
   }
  };
  $rootScope.fetch_status = statusery.get_status.bind(statusery);

  $scope.$on('wtg.interact.device.login', function (/*event*/) {
   $scope.session = EventHandler.getAccountInfo();
  });
  $scope.$on('$routeChangeStart', function(/*$event, next, current*/) { //on routechange event
   //Set the active navigation link
   var path = $location.path();
   path = path.match(/support/g);
   if($rootScope.is_audio_call_accepted) $('#videocall-modal').fadeIn();
  });
  var the_nav; // TODO: should probably not exist
  function set_nav(nav) {
   the_nav = nav;
  }
  this.isNavSelected = function (checkNav) {
   return the_nav === checkNav;
  };
  var that = this;
  var unonceVCL = $scope.$on('$viewContentLoaded',function() {
   /* TODO: I need to deregister the listener here, because view content is
      loaded more than once, which it shouldn't at this level. */
   unonceVCL();
   const lang_id = intl.get_language();
   gettextCatalog.setCurrentLanguage(lang_id);
   $('#languageSelector').niftyLanguage({
    selectedOn : '#lang-'+lang_id,
    onChange:function(e) {
     gettextCatalog.setCurrentLanguage(e.id);
     var id=e.id;
     $rootScope.$applyAsync(function(){
      wtgcp.default_language = id; // TODO: why?!
      $rootScope.strings=intl.set_language(id);
      IDA.set_language(id);
     });
     PERSISTENCE.put('language',id);
     // TODO: broadcast something
    }
   });
  });
  $scope.notifications = [
   /*{
   image: "img/av1.png",
   title: "David Gómez",
   subtitle: "Sent you a picture"
   }*/
  ];
  function strip_prefix(str,pfx) {
   if(!str.startsWith(pfx)) return undefined;
   return str.substring(pfx.length);
  }
  $scope.$on('onChatMessage', function (event, conid, accid, displayName, message, mSec, chid) {
   var result; // XXX: why is it called "result"?!
   var nocc = strip_prefix(message,'command|confirmation|');
   if(nocc) {
    var grant = (nocc=='true');
    result = grant?$rootScope.strings.str_terminal_access_accepted:$rootScope.strings.str_terminal_access_rejected;
    var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.did==$rootScope.deviceID});
    if(tap) {
     $rootScope.disable_send_btn = tap.btn_disable=!($rootScope.terminalAccessed=tap.grant=grant);
     $rootScope.send_btn_text = grant?$rootScope.strings.str_send:$rootScope.strings.str_request_access;
     if(grant) clearTimeout(tap.timer);
    }
   }else result = message;
   $rootScope.appendMessageToHistory({
    convid: conid, acid: accid,
    display_name: displayName,
    msg: result,
    msgtime: mSec, // TODO: check to make sure it's a proper time (likely not)
    channelid: chid,
   });
   if($rootScope.conversationID!= conid || document.visibilityState!="visible") {
    $rootScope.showToasterMsg('info',WTG.fmt($rootScope.strings.str_customer_response,{conid:conid}),
    $rootScope.strings.str_notification_header);
    var convo = INTERACT.get_conversation(+conid);
    if(!convo) L.error({conid:conid,message:message},"received message for unexistent conversation");
    else convo.set_unreads();
   }
  });
  $scope.$on('onRemMessage', function (event, conid, accid, displayName, message/*, mSec, chid*/) {
    L.trace({conid:conid,accid:accid,displayName:displayName,message:message},"remote message");
    if(INTERACT.get_myself().id==accid) return;
    var o = JSON.parse(message);
    if(["error","logout"].indexOf(o.result)!=-1) {
     L.warn({o:o},"WIP: remote error, let's see what's going on");
     $rootScope.remote_error_message = o.details;
     if($rootScope.virtualConnection.tid==TODO.test_id.SPEED_TEST) speed_test.stop();
     $('#remote-fail-modal').modal();
     $rootScope.enableRemoteButton();
     if(o.result=="logout") {
      var devices = INTERACT.get_account(accid).d;
      var dev = devices.find(function(x){return x.id==$rootScope.deviceID});
      dev.active = false;
      $rootScope.showProviderInfo=false;
      $rootScope.showTestStatusTable = false;
      updateOrbitCircle({});
      $rootScope.enableLiveResultsControl = false;
      $rootScope.showAwakeButton = true;
      if(!$rootScope.isHidden("h2g-linear-view")) $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_device_offline);
      else $rootScope.orbitX.setStatus("","",$rootScope.strings.str_device_offline);
     }
    }
  });
  $scope.$on('onDiagPermission', function (event, parray, acid) {
   if(parray && parray.length) EventHandler.APILAYER.createConversation({accountID: acid, channelID: 3});
   else EventHandler.APILAYER.grantRequestPermissionToAClient(acid,[6],[3],3);
  });
  $scope.$on('onPermissionStatus', function (event, pid, statuscode, acid/*, userdata*/) {
   if((statuscode == 1) && acid) EventHandler.APILAYER.createConversation({accountID: acid, channelID: 3});
   else L.warn({pid:pid,statuscode:statuscode,acid:acid},"TODO: fill logic to show status");
  });
  $scope.$on('wtg.interact.create-conversation:'+INTERACT.D.xaction.channel.diagres, function (event, cc) {
   if(cc.status <= 1) {
    INTERACT.get_account(cc.acid).dcid = cc.convid;
   }
   else L.warn({cc:cc},"TODO: fill logic to show failure");
  });

  $scope.$on('onDiagMessage', function (event, conid, accid, displayName, message, mSec, chid,messageID) {
   var tid;
   if(message=="3|6") tid = 121;        // TODO: magic
   else if(message=="3|7") tid = 122;   // TODO: magic
   else return;
   var st = $rootScope.SecurityTests.find(function(x){ return x.did==$rootScope.deviceID && x.tid==tid });
   if(!st) return L.warn({convid:conid,acid:accid,message:message,chid:chid,msgid:messageID},"I'm not sure but I suspect it may be not a normal condition. If it is, let's just remove this log");
   st.mid = st.fid = messageID;
  });

  $scope.$on('onDiagResultMessage', function on_diag_result_message(event, conid, accid, displayName, message, mSec, chid, messageID, deviceID) {
   if(deviceID!=$rootScope.deviceID) return;
   var sc = strip_prefix(message,'6|status|');
   if(sc) {
    var statsc = strip_prefix(sc,'change|');
    if(sc=='connection_change') {
     $rootScope.virtualConnection = {};
     sendInitialRequests();
    }
    else if(statsc) {
     updateResultChange(JSON.parse(statsc));
    }else{ // '6|status|change|', or else:
     statusery.feed_in(sc,{message:message});
    }
   }else if((sc = strip_prefix(message,'6|getjson|'))) {
    getjsonry.put_json(sc,{message:message});
   }else if(message.startsWith('command|')) {
    var result = prepareTerminalMessage(message);
    $rootScope.appendMessageToHistory({
     convid: conid, acid: accid,
     display_name: displayName,
     msg: result,
     msgtime: mSec, // TODO: check the type
     channelid: chid,
    });
   }else if((sc = strip_prefix(message,'submission|'))) {
    var osub = JSON.parse(sc);
    var devices = INTERACT.get_account(accid).d;
    var dev = devices.find(function(x){return x.id==deviceID});
    if(osub.type==1) { // submission query response // TODO: magic
     $rootScope.enableLiveResultsControl = true;
     dev.result_submission = $rootScope.submit_results.find(function(r) { return r.id===osub.value});
    }else if(osub.value=="ok"){ // app responded with 'ok' when it successfully chaged the submission type
     dev.result_submission = $rootScope.submit_results.find(function(r) { return r.id===osub.type});
     var m =prepareSubmitResultEventMessage(message);
     $rootScope.appendMessageToHistory({
      convid: conid, acid: accid,
      msg: m,
      msgtime: new Date(),
      channelid: INTERACT.D.xaction.channel.diagres
     });
    }
   }else if((sc = strip_prefix(message,'result|'))) {
    var ores= JSON.parse(sc);
    var e = ((Object.keys($rootScope.evaluations).length===0)?"":$rootScope.evaluations[ores.ecode].s);
    var thetest = $rootScope.tests.find(function(x){return x.test_id==ores.test_id});
    var msg  = $rootScope.strings.str_diagnostic_result+"<br/>"+thetest.test_name+" - "+ e + " - " + ores.test_result;
    $rootScope.appendMessageToHistory({
     convid: conid, acid: accid,
     msg: msg,
     msgtime: new Date(),
     channelid: INTERACT.D.xaction.channel.diagres
    });
   }else if((sc = strip_prefix(message,'9|request|response|'))) {
    var oreqres= JSON.parse(sc);
    $rootScope.$broadcast("updateRouterConfigurationInfo", "", oreqres, oreqres.eval);
   }else if((sc = strip_prefix(message,'9|setvalue|response|'))) {
    var osetres= JSON.parse(sc);
    L.trace({o:osetres},"setvalue response");
    ROUTERCONFIG.updateData(osetres);
   }else if((sc = strip_prefix(message,'10|speedtest|'))) {
    $rootScope.speedtest_capabilities = JSON.parse(sc);
    if($rootScope.loadSpeedTestScreen) speed_test.refresh_screen($rootScope.speedtest_capabilities);
    /* TODO: now I of course comment this silencing of anything not expecteed enough out:
     var cap = message.substring(13);
     $rootScope.speedtest_capabilities = cap&&JSON.parse(cap)||{"e2e":{"dl":true,"ul":true}};
     * we *HAVE* to see errors before we can make sensible decision regarding silencing it, the code
     * above doesn't look like sensible decision at all */
   }else if((sc = strip_prefix(message,'6|publicIP|'))) {
    INTRACTABLE.request("netutil/ip/lookup",
     {addr:($rootScope.publicIP=sc)},
     function(e, r) {
      if(e) return L.error({err:e,addr:sc},"error fetching provider information");
      if(r._S!='ok') return L.warn({r:r,addr:sc},"error fetching provider information");
      $rootScope.showProviderInfo=true;
      $rootScope.providerName = r.provider?r.provider.name:$rootScope.strings.str_provider_unknown;
     }
    );
   }else if((sc = strip_prefix(message,'6|diagnose|'))) {
    if(JSON.parse(sc).s=='done') $rootScope.showDiagnoseOverlayScreen=false;
   }else
    L.warn({conid:conid,displayName:displayName,message:message,mSec:mSec,chid:chid,messageID:messageID,deviceID:deviceID},"could not interpret incoming message supposedly about diagnostics results");
  });

  $scope.$on('wtg.interact.create-conversation:'+INTERACT.D.xaction.channel.remote, function (event, cc ) {
   if((cc.status==0)||(cc.status==1)) { // TODO: magic
    EventHandler.createRemoteVirtualConnection($rootScope.remoteAID,$rootScope.remoteDID);
   }
   // No permission to access remote device
   else L.info('No permission to access remote device');
  });
  $scope.$on('wtg.interact.diag-result', function (event, dr) { // messageID, testID,eCode, mseconds, accountID, deviceID, tResult, tComment, sessionID, resData) {
   if(!dr.testid) return L.warn({dr:dr},"no test id for diag result");
   $rootScope.resultGroups = [];
   var account = INTERACT.get_account(dr.acid);
   if(!account) return L.warn({dr:dr},"no account for diag result");
   var sd = account.sd;
   if(!account.tr[sd]) account.tr[sd] = {total: 0, results: []};
   var tidn = dr.testid;
   account.tr[sd].results.unshift({rid:0,tid:tidn,ts:new Date(),te:dr.evalcode,tr:dr.result,tc:dr.comment,si:null,trd:dr.rdata,cid:dr.sid});
   ++account.tr[sd].total;
   applyResults(account, sd, account.tr[sd].results);
   var thetest = $rootScope.tests.find(function(x){return x.test_id==tidn});
   var test_name = thetest?thetest.test_name:tidn; // TODO: is it not a bigger prob?
   var msg  = $rootScope.strings.str_diagnostic_result+"<br/>"+test_name+" - "+ (
    (!Object.keys($rootScope.evaluations).length)?"":$rootScope.evaluations[dr.evalcode].s
   ) + " - " + dr.result; // TODO: bad string building
   // TODO: WTF
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: dr.acid,
    msg: msg, msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.diagres
   });
   if((tidn==117)&&(dr.evalcode==2)) { // TODO: magic
    var split = dr.result.split(', ');
    var lat = split[0];
    var lng = split[1];
    $rootScope.$broadcast("showDeviceLocation",lat,lng);
   }
   else if((tidn==121)||(tidn==122)) { // TODO: magic
    var thedid = dr.devid;
    // TODO: I suspect this is some dead code, because I've never seen this
    // "findInfex" call error out despite it being pretty much undefined
    var index = $rootScope.SecurityTests.findInfex(function(x){return x.did==thedid && x.tid==tidn});
    if(index<0) return;
    if(dr.evalcode==2) $rootScope.SecurityTests[index].mid = dr.mid-1; // TODO: magic
    else $rootScope.SecurityTests.splice(index,1);//removing entry as the request fails to process
   }
   if(!$rootScope.isHidden('circle')) H2GRESULTS.hideBusyState();
  });
  $scope.$on('onWRTCConfigMessage', function (event, conid, accid, displayName, message, mSec, chid,msgid,did) {
   L.trace({message:message,did:did},"onWRTC ConfigMessage");
   var selfid = INTERACT.get_myself().id;
   var data=JSON.parse(message);
   if(selfid==data.by) return L.trace("self WRTC message");
   if($rootScope.is_in_video_call&&data.type=="video-request") {
    EventHandler.APILAYER.sendMessage({
     convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({type:'video-response',accept:false,reason:'busy',
           by:selfid,to:data.by}),
     devid: did, validity: 5000});
    return;
   }
   if(/^(front|back)-camera-response/.test(''+data.type))
    return $rootScope.$broadcast('wtg.wrtc.camera.'+(data.type.split('-')[0])+'.response',data);
   if(selfid!=data.by){
    if(!$rootScope.accountID&&data.type=="video-request"){// current page is not the support page
     L.trace("current page not user one");
     $rootScope.showIncomingCallAlert(data.by,conid,did);
    }else if($rootScope.accountID&&data.type=="video-request"&&$rootScope.accountID!=data.by){//currently in support page but call request from new user
     if(!$rootScope.is_incoming_alert_on&&!$rootScope.is_in_video_call){
      L.trace("current page is user one");
      $rootScope.showIncomingCallAlert(data.by,conid,did);
     }else{
      L.trace("alert already there");
      EventHandler.APILAYER.sendMessage({
       convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
       msg: JSON.stringify({type:'video-response',accept:false,reason:'busy',
             by:selfid,to:accid}),
       devid: did, validity: 5000});
     }
    }else{
     data.did=did;
     EventHandler.WRTC.handleMessage(data);
    }
   }else{
    L.trace("self message");
   }
   if(data.type=="video-offer-response")
    $rootScope.$broadcast('wtg.wrtc.video-offer-response', data);
   else if(data.type=="video-stream-request")
    $rootScope.$broadcast('wtg.wrtc.video-stream-request', data);
  });
  $scope.featureNotAvailable = function () {
   Notification.featureNotAvailable();
  };
  $scope.check_domain_validity = function domain_validate(mv) {
   if(!mv) return $q.reject();
   var rv = $q.defer();
   INTRACTABLE.request('domain/lookup', { name: mv }, function(e,r) {
    if(e) {
     L.error({err:e,r:r,domain:mv},"error looking up the domain");
     $scope.forgot_password_error = $rootScope.strings.str_connection_error;
     rv.reject();
    }
    else if(r && r._S =='notfound') {
     $scope.forgot_password_error = $rootScope.strings.str_organization_not_exists;
     rv.reject();
    }
    else if(r && r._S =='ok') rv.resolve();
    else {
     L.error({err:e,r:r,domain:mv},"error looking up the domain");
     $scope.forgot_password_error = $rootScope.strings.str_connection_error;
     rv.reject();
    }
   });
   return rv.promise;
  };
  $rootScope.resetPasswordClick = function() {
   var input = $('#reset_email').val();
   var domain_name = $('#domain_name').val();
   function errorTimeout(){
    $timeout(function () {
     $scope.email_error_message = '';
    }, 5000);
   }
   var channel=(U.is_valid_mobile(input)&&'mobile')||(U.is_valid_email(input)&&'email');
   if(!channel){
    $scope.email_error_message = $rootScope.strings.str_invalid_input;
    return errorTimeout();
   }
   INTRACTABLE.request("oops",
    {I:input,IT:channel,O:channel,D:wtgcp.domain,DN:domain_name},
    function(e, r) {
     var err = $rootScope.strings.str_error_attempting_to_reset_password;
     if(r){
      if(r._S=='ok') return $location.path( '/email-success' );
      if(r._S=='notfound') err = $rootScope.strings.str_user_does_not_exist;
     }
     L.error({err:e,r:r},"Error resetting password");
     $scope.email_error_message = err;
     errorTimeout();
    });
  };
  function tweak_result(tr) {
   try { /* TODO: eliminate test id magic one day */ 
    if(tr.id==172 && tr.result=='ok') {
     if( JSON.parse(tr.result_data).port_duplex=='unknown' )
      Object.assign(tr,{details: $rootScope.strings.str_unknown_providerline_status,
                        result: 'warn'});
    }else if(tr.tid==172 && tr.te==INTERACT.D.xaction.result_evaluation.ok) {
     if( JSON.parse(tr.trd).port_duplex=='unknown' )
      Object.assign(tr,{tr: $rootScope.strings.str_unknown_providerline_status,
                        te: INTERACT.D.xaction.result_evaluation.warn });
    }
   }catch(err) { L.error({err,tr},"failed to parse uplink test results") }
   return tr;
  }
  function prepareGroups(tests){
   $rootScope.resultGroupsCount = 0;
   $rootScope.resultGroups=[];
   tests.map(tweak_result).forEach(function(test) {
    var tid = test.tid;
    if(tid==0) return;
    var display = true;
    var thetest = $rootScope.tests.find(function(x){return x.test_id==tid});
    if(!thetest) return;
    $rootScope.resultGroups.forEach(function(entry) {
     if(tid== entry.id) display = false;
    });
    var testName = thetest.test_name;
    var gid = thetest.group_id;
    var thegroup = $rootScope.testGroups.find(function(x){return x.group_id==gid});
    if(!thegroup) return;
    var groupName = thegroup.test_group_name;
    var testEntry = {};
    if(display) {
     testEntry = {
      id:tid,name:testName,group_id:gid,group_name:groupName,evaluation:test.te,result:test.tr,comment:test.si,
      ts:test.ts,transaction_id:test.trid,firstentry:display,display:display,childs:[]};
     $rootScope.resultGroups.push(testEntry);
     $rootScope.resultGroupsCount++;
    }
    else {
     testEntry = {group_id:gid,evaluation:test.te,result:test.tr,comment:test.si,ts:test.ts,transaction_id:test.trid,firstentry:display,display:display};
     $rootScope.resultGroups.find(function(x){return x.id==tid}).childs.push(testEntry);
    }
   });
   overview_tests.forEach(function(test) {
    var o = $rootScope.resultGroups.find(function(x){return x.id==test.test_id});
    if(!o) return;
    var g = $rootScope.testGroups.find(function(x){return x.group_id==26});
    if(!g) return;
    var t=Object.assign({},o);
    t.group_name=g.test_group_name;
    t.group_id=g.group_id;
    $rootScope.resultGroups.push(t);
    $rootScope.resultGroupsCount+=t.childs.length;
   });
   $rootScope.fullResults = $rootScope.resultGroups;
  }
  $rootScope.filterTestResults = function(tid,gname){
   $rootScope.$applyAsync(function(){
    var firstentry = true;
    var show = false;
    $rootScope.fullResults.forEach(function(entry) {
     if(tid == entry.id && gname==entry.group_name) {
      (firstentry)?(show=entry.toggle):(entry.display=show);
      firstentry = false;
      entry.toggle = !show;
      $rootScope.resultGroupsCount = (!show)?$rootScope.resultGroupsCount+entry.childs.length:$rootScope.resultGroupsCount-entry.childs.length;
      $rootScope.tableParams.total($rootScope.resultGroupsCount);
      $rootScope.tableParams.reload();
     }
    });
   });
  };
  function prepareTestResultMessage(transaction) {
   var r = $rootScope.fullResults.map(function(r) {
    if(!r) return null;
    if(r.transaction_id==transaction.transaction_id) return r;
    if(!r.childs) return null;
    var sr = r.childs.find(function(x){return x.transaction_id==transaction.transaction_id});
    if(!sr) return null;
    sr.name=r.name;
    return sr;
   }).filter(function(r){return !!r}).map(function(r) {
    return r.name+": "+r.result+" ("+$rootScope.evaluations[r.evaluation].s+")";
   });
   if(r.length) return $rootScope.strings.str_diagnostic_result+"<br/>"+r.join("<br/>")+"<br/>";
   if(transaction.content.indexOf('|')<0) return transaction.content;
   return '';
  }
  $rootScope.isFeatureAvailable = function(feature) {
   var acid = +$routeParams.aid;
   var account = INTERACT.get_account(acid);
   var sd = account.sd;
   if(account.d[sd] && (account.d[sd].man == 'Apple')) {
    if((feature == 'camera') || (feature == 'wipe') || (feature == 'lock')) return false;
   }
   return true;
  };
  $rootScope.refreshResults = function() {
   $('#resultsrefreshicon').addClass('fa-spin');
   var acid = $rootScope.accountID;
   var account = INTERACT.get_account(acid);
   var sd = selDevIndex;
   INTRACTABLE.request("test/results",
    {"DID": account.d[sd].id,'S':'-rid','T':1,'L':10},
    function(e, r) {
     if(!e) {
      if(r._S=='auth') $rootScope.showLoginPage();
      else if(r._S=='ok') {
       account.tr[sd] = { total: r.total, results: r.results };
       applyResults(account, sd, r.results);
       if(Object.keys($rootScope.fullResults).length != 0) $rootScope.lastTestResultDate = $rootScope.ISO8601DateFormat($rootScope.fullResults[0].ts);
      }
     }
     $('#resultsrefreshicon').removeClass('fa-spin');
    });
  };
  $rootScope.updateAppsList = function() {
   INTRACTABLE.request("apps/get",
   {"DID": $rootScope.deviceID },
   function (e, r) {
   $timeout(function () {
    $rootScope.appsList = ((!e) && (r._S == 'ok')) ? r.apps : {};
    $('.footable').footable(); //Initialize FooTable!
    $('.footable').data('footable').reset(); //reset data
    $('.footable').data('footable').redraw();
    $rootScope.lastAppsFetchTime = $rootScope.ISO8601DateFormat((new Date()).toISOString());
   }, 100);
   });
  };
  $rootScope.fetchMDMdetails = function() {
   INTRACTABLE.request("mdm/mobileiron/device/mdm",
    { "imei": $rootScope.imei},
    function (e, r) {
     $rootScope.mdmEnabled = false;
     $rootScope.mdmDetails = [];
     if ((!e) && (r._S == 'ok')) {
      $rootScope.mdmEnabled = r.mdm;
      if(r.mdm) {
       INTRACTABLE.request("mdm/mobileiron/device/details",
        { "uuid": r.uuid},
        function (e, r) {
         if ((!e) && (r._S == 'ok')) {
          for(var x in r.details) {
           $scope.group = "";
           if($rootScope.mdmUserRelated.indexOf(x)!=-1) $scope.group = $rootScope.mdmGroups[0];
           else if($rootScope.mdmSecurity.indexOf(x)!=-1) $scope.group = $rootScope.mdmGroups[1];
           else if($rootScope.MDM.indexOf(x)!=-1) $scope.group = $rootScope.mdmGroups[2];
           else if($rootScope.mdmAndroid.indexOf(x)!=-1) $scope.group = $rootScope.mdmGroups[3];
           $rootScope.mdmDetails.push({name:x,value:r.details[x],group:$scope.group});
          }
         }
        });
      }
     }
     $('#mdmrefreshicon').removeClass('fa-spin');
    });
   // TODO: most likely this is not needed, because there's literally NOTHING
   // happens in this function before forcing apply, but just in the unlikely
   // event that it was for the benefit of this function caller.
   $rootScope.$applyAsync(function(){});
  };
  var debounceUpdateOrbitCircleApplyPromise;
  function filter_expired_results(r) {
   for(var c in r){
    for(var t in r[c]){
     if(r[c][t].expired){
      /*even the test is expired, excepted if it is configured to show*/
      if(excepted_expired_tests[r[c][t].id]) continue;
      delete r[c][t];
     }
    }
   }
  }
  function updateOrbitCircle(testStatus) {
   for(var c in testStatus) for(var t in testStatus[c])
    testStatus[c][t] = tweak_result(testStatus[c][t]);
   filter_expired_results(testStatus);
   TR.setResults(testStatus);
   TR.evaluate();
   $rootScope.lastCircleUpdateTime = "";
   if(!$rootScope.orbitX.d.orbit) return;
   $rootScope.orbitData = [];
   for (var prop in testStatus) {
    if (testStatus.hasOwnProperty(prop)) {
     for (var prop1 in testStatus[prop]) {
      if(!testStatus[prop].hasOwnProperty(prop1)) continue;
      var tp = testStatus[prop][prop1];
      var trd = {};
      if(tp.result_data) try {
       trd = JSON.parse(tp.result_data);
      }catch(ex) {
       L.warn({rd:tp.result_data},"bad json arrived: "+tp.result_data);
      }
      $rootScope.orbitData.push({
       "gn":prop,"tid":tp.id,"tn":prop1,"eval":tp.result?tp.result:"","summary":tp.details?tp.details:"",
       "t":tp.ts?(new Date(tp.ts*1000)).toISOString():0,"trd":trd,"ignore":tp.ignore,"turn_off":tp.turn_off
      });
     }
    }
   }
   if(Object.keys(testStatus).length != 0) $rootScope.lastCircleUpdateTime = $rootScope.ISO8601DateFormat((new Date()).toISOString());
   var sort_order = {prob:1,warn:2,ok:3};
   $rootScope.orbitData.sort(function(a,b) {
       return (sort_order[a.eval]-sort_order[b.eval]);
   });
   var components = {device: "device", router: "wifi_router", internet: "internet", network: "mobile_bs"};
   if($rootScope.isHidden('h2g-linear-view')) {
    for (var lcomp in components)
     $rootScope.orbitX.d.orbit.setStatusX(lcomp,getStatus(components[lcomp]));
    $rootScope.orbitX.d.orbit.changeArcColor('device','network',getStatus("mobile"));
    $rootScope.orbitX.d.orbit.changeArcColor('network','internet',getStatus("mobile_bb"));
    $rootScope.orbitX.d.orbit.changeArcColor('device','router',getStatus("wifi"));
    $rootScope.orbitX.d.orbit.changeArcColor('router','internet',getStatus("fixed_line"));
    if(is_auto_diagnostics_off) $rootScope.orbitX.setStatus("","",$rootScope.strings.str_auto_diagnostics_off);
    else $rootScope.orbitX.setStatus(getStatusCount("prob"),getStatusCount("warn"));
   }
   else {
    $rootScope.wtg_fixedline.reset();
    for (var nlcomp in components) $rootScope.wtg_fixedline.set_status({c1:nlcomp,r:getStatus(components[nlcomp])});
     $rootScope.wtg_fixedline.set_status({c1:'device',c2:'router',r:getStatus("wifi")});
     $rootScope.wtg_fixedline.set_status({c1:'router',c2:'internet',r:getStatus("fixed_line")});
     if(is_auto_diagnostics_off) $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_auto_diagnostics_off);
     else if($rootScope.orbitData.length>0) $rootScope.wtg_fixedline.setSummary(getStatusCount("prob"),getStatusCount("warn"));
     else $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_device_offline);
   }
   if(debounceUpdateOrbitCircleApplyPromise) $timeout.cancel(debounceUpdateOrbitCircleApplyPromise);
   debounceUpdateOrbitCircleApplyPromise = $timeout(angular.noop,800);
  }
  function orbit_has_eval(gname,ev) {
   return $rootScope.orbitData.some(function(x) {
    return x.gn==gname && x.eval==ev && !x.ignore;
   });
  }
  function getStatusCount(ev) {
   // TODO: given the function is called twice every time it's probably wiser
   // to have one function returning aggregated statistics
   return $rootScope.orbitData.reduce(function(p,c) {
    return p + +(c.eval==ev&&!c.ignore);
   },0);
  }
  function getStatus(gname) { // TODO: this is a bad generic name and we have similarly named functions even within this file
   // TODO: and of course it still can be optimized and done in a single pass
   if(orbit_has_eval(gname,"prob")) return 'prob';
   if(orbit_has_eval(gname,"warn")) return 'warn';
   if(orbit_has_eval(gname,"ok")) return 'ok';
   return "unknown";
  }
  $scope.call_timer=null;
  $rootScope.hideIncomingCallAlert=function() {
   $("#notification").fadeOut("slow");
   if($scope.call_timer) clearTimeout($scope.call_timer);
  };
  function gotLocalStream(cid,aid,d,stream) {
   $rootScope.localStream=stream;
   document.getElementById('localVideo').srcObject = stream;
   EventHandler.WRTC.set_local_stream(stream);
   EventHandler.WRTC.set_target(cid,d);
   EventHandler.APILAYER.sendMessage({
    convid: cid, channelid: INTERACT.D.xaction.channel.videochat,
    msg: JSON.stringify({type:'video-response',accept:true,
          by:INTERACT.get_myself().id,to:aid}),
    devid: d, validity: 5000});
   $("#btn_video_icon").removeClass("fa-phone-x");
   $("#btn_video_icon").addClass("fa-phone-x");
  }
  $rootScope.showIncomingCallAlert = function (acid,conid,did) {
   if(!$rootScope.is_incoming_alert_on||!$rootScope.is_in_video_call){
    $rootScope.is_incoming_alert_on=true;
    var username="";
    $rootScope.deviceID=did;
    var acida = INTERACT.get_account(+acid);
    if(acida) {
     username = acida.get_display_name()||'';
    }
    /* TODO: Now it would be really interesting to know whether `un` and
     * `username` are supposed to be the same and if yes why do we retrieve it
     * twice and if no why do we use different usernames to announce the same
     * event? */
    // TODO: see copypaste in support-chat and in here marked "1553980282"
    var account = INTERACT.get_account($rootScope.accountID);
    var p = account && account.get_profile();
    var un=p?(p.first_name||p.last_name||$rootScope.strings.str_user):$rootScope.strings.str_user;
    $rootScope.appendMessageToHistory({
     convid: conid, acid: acid,
     msg: WTG.fmt($rootScope.strings.str_user_call_requested,{username:un}),
     msgtime: new Date(),
     channelid: INTERACT.D.xaction.channel.videochat
    });
    $("#notification").empty();
    $("#notification").fadeIn("slow").append('<strong>'+WTG.fmt($rootScope.strings.str_incoming_call_alert_msg,{username:username})+'</strong>&nbsp;'+
    '<button class="call_accept btn btn-success" style="border-radius:50%;" ><i class="fa fa-phone" style="color:rgb(220,220,220)"></i></button>&nbsp;<button class="call_reject btn btn-danger" style="border-radius:50%;"><i class="fa fa-phone" style="color:rgb(220,220,220)"></i></button>');
    $scope.updateCallStatus($rootScope.strings.str_incoming_call,1);
    $rootScope.btnVideoCallDisable = true;
    $scope.call_timer=setTimeout(function(){ //automatic call rejection
     $("#notification").fadeOut("slow");
     $scope.updateCallStatus($rootScope.strings.str_call_cancel_timeout,0);
     $rootScope.btnVideoCallDisable = false;
     $rootScope.is_incoming_alert_on=false;
     $("#btn_video_icon").removeClass("fa-phone-x");
     $("#btn_video_icon").addClass("fa-phone");
     $rootScope.is_in_video_call=false;
     var selfid = INTERACT.get_myself().id;
     $rootScope.appendMessageToHistory({
      convid: conid, acid: selfid,
      msg:$rootScope.strings.str_call_cancel_timeout,
      msgtime: new Date(),
      channelid: INTERACT.D.xaction.channel.videochat
     });
     EventHandler.APILAYER.sendMessage({
      convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
      msg: JSON.stringify({type:'video-response',accept:false,reason:"not-available",
            by:selfid,to:acid}),
      devid: did, validity: 5000});
    },30000);
    /* TODO: do I get it right? We add the new click handler **every time** the
     * call alert is shown?! */
    $(".call_accept").click(function(){ // If the call accepted on notification
     $rootScope.is_in_video_call=true;
     $rootScope.callDetails.startTime = Math.round(new Date().getTime()/1000);
     $rootScope.callDetails = {callby:acid,callType:"incoming",callto:INTERACT.get_myself().id,conversationID:conid,deviceID:did,otherside:acid};
     $("#notification").fadeOut("slow");
     $scope.updateCallStatus($rootScope.strings.str_call_accepted,1);
     $rootScope.btnVideoCallDisable = false;
     $rootScope.is_incoming_alert_on=false;
     $rootScope.callDetails.client_call_status='str_video_info_in_audio_call';
     if($scope.call_timer) clearTimeout($scope.call_timer);
     if($rootScope.accountID!=acid){
      L.trace("Navigating to support page");
      $location.path('/support/'+ acid +'/'+ conid);
     }
     $rootScope.$applyAsync(function(){});
     navigator.mediaDevices.getUserMedia({audio:true}).then(function(s) {
      $rootScope.$applyAsync(function(){
       $rootScope.is_audio_call_accepted = true;
      });
      gotLocalStream(conid,acid,$rootScope.deviceID,s);
      $('#videocall-modal').fadeIn();
     })
     .catch(function(err) {
      $("#btn_video_icon").removeClass("fa-phone-x");
      $("#btn_video_icon").addClass("fa-phone");
      $rootScope.is_in_video_call=false;
      EventHandler.APILAYER.sendMessage({
       convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
       msg: JSON.stringify({type:'video-response',accept:false,reason:err.name,
       by:INTERACT.get_myself().id,to:acid}),
       devid: did, validity: 5000
      });
      switch(err.name) {
       case 'NotAllowedError':
        $scope.updateCallStatus($rootScope.strings.str_agent_denied_audio_permissions,0);
        break;
       case 'NotFoundError':
        $scope.updateCallStatus($rootScope.strings.str_failed_to_detect_audio_devices,0);
        break;
       default:
        L.warn({e:err.name},"unhandled error in get user media");
      }
     });
    });
    $(".call_reject").click(function(){ // If the call rejected on notification
     $("#notification").fadeOut("slow");
     $scope.updateCallStatus($rootScope.strings.str_agent_cancel_call,0);
     $rootScope.btnVideoCallDisable = false;
     $rootScope.is_incoming_alert_on=false;
     if($scope.call_timer) clearTimeout($scope.call_timer);
     var selfid = INTERACT.get_myself().id;
     $rootScope.appendMessageToHistory({
      convid: conid, acid: selfid,
      msg: $rootScope.strings.str_agent_cancel_call,
      msgtime: new Date(),
      channelid: INTERACT.D.xaction.channel.videochat
     });
     EventHandler.APILAYER.sendMessage({
      convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
      msg: JSON.stringify({type:'video-response',accept:false,
            by:selfid,to:acid}),
      devid: did, validity: 5000});
    });
   }
   else {
    EventHandler.APILAYER.sendMessage({
     convid: conid, channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({type:'video-response',accept:false,reason:'busy',
           by:INTERACT.get_myself().id,to:acid}),
     devid: did, validity: 5000});
   }
  };
  $rootScope.showDiagnosticAlert = function (targetUser, targetDevice, testID) {
   L.trace({to_user:targetUser,to_device:targetDevice,test:testID},"Send diagnostics request to accountID: " + targetUser + " and deviceID: " + targetDevice+" tid: "+testID);
   launchAlert('primary', '<strong>'+$rootScope.strings.str_diagnostic_request+'</strong><br/>'+WTG.fmt($rootScope.strings.str_test_request,{testID:testID}),'5000');

   return true;
  };
  function launchAlert(type, content, timer) {
   //Types: "info", "primary", "success", "warning", "danger", "mint", "purple", "pink", "dark"
   //Timer: duration in ms, 0 to disable autoclose
   var contentHTML = '<div class="alert alert-' + type + ' media fade in mar-no pad-no">' + content + '</div>';
   $.niftyNoty({
    //title: title,
    focus: true,
    type: type,
    container: 'floating',
    html: contentHTML,
    timer: timer
   });
   L.trace("Alert sent");
   return true;
  }
  function changeSupportView(pid) {
    var p = wtgcp[pid||wtgcp.product];
    if(!p) L.error("no product configured or supplied");
    supported_tests = p.supported_tests;
    supported_groups = p.supported_groups;
    overview_tests_list = p.overview_tests;
    excepted_expired_tests=(p.excepted_expired_tests||[]).reduce(function(p,c) {
     p[c] = true;
     return p;
    },{});/*p.excepted_expired_tests;*/
    $rootScope.hidden_features = p.hidden_features.reduce(function(p,c) {
     p[c] = true;
     return p;
    },{});
  }

  function loadTestGroups() {
   $rootScope.tests = [];
   $rootScope.testGroups = [];
   overview_tests = [];
   var tname,gname;
   tname=gname="";
   if($rootScope.strings.tests){
    $scope.tests = $rootScope.all_tests.map(function(x) {
     tname = getTestName(x.test_id);
     if(tname!="") x.test_name = tname;
     return x;
    });
   }
   else $scope.tests = $rootScope.all_tests;

   if($rootScope.strings.groups){
    $scope.groups = $rootScope.all_groups.map(function(x) {
     gname = getGroupName(x.group_id);
     if(gname!="") x.test_group_name = gname;
     return x;
    });
   }
   else $scope.groups = $rootScope.all_groups;

   if(supported_tests) {
    supported_tests.forEach(function(tid) {
     var t = $scope.tests.find(function(x){return x.test_id==tid});
     if(t)
      $rootScope.tests.push(t);
     else
      L.warn({tid:tid},"unknown test id");
    });
   }
   else $rootScope.tests = $scope.tests;

    $scope.groups.forEach(function(sg) {
     if((supported_groups && supported_groups.indexOf(sg.group_id)<0)
         ||(!$rootScope.tests.find(function(x){return x.group_id==sg.group_id})))
      return;
     $rootScope.testGroups.push(sg);
    });
    var tg = $rootScope.testGroups.find(function(x){return x.visible==1});
    $rootScope.selectedGroup = tg;
    $rootScope.filteredTestList = $rootScope.tests.filter(function(x){
     return (x && x.group_id == tg.group_id && x.visible);
    });
    $rootScope.selectedTest = $rootScope.filteredTestList[0];
    if(overview_tests_list) {
     overview_tests_list.forEach(function(tid) {
      var t = $scope.tests.find(function(x){return x.test_id==tid});
      if(t) overview_tests.push(t);
      else L.warn({tid:tid},"unknown overview test id");
     });
    }
  }

  function prepareTerminalMessage(message) {
    // TODO: I'm afraid to even think of what are those closing </b> tags about…
    var i = message.indexOf("response|");
    var cname = "";
    var result;
    if(i!=-1) {
     cname = message.substring(8,i-1);
     result  = WTG.fmt($rootScope.strings.str_terminal_command,{command:cname})+"<br/>"+$rootScope.strings.str_response+"<br/>" +message.substring(i+9);  //terminal command response
     result = result.replace(/\n/g, "<br/>");
    }
    else {
     cname = message.substring(10);
     result = WTG.fmt($rootScope.strings.str_terminal_command,{command:cname}); //terminal command request
    }
    return result;
  }
  $rootScope.getMedia = function(conf,cb) {
   navigator.getUserMedia=EventHandler.WRTC.getSupportedMedia();
   L.trace({conf:conf},"getting user media with configuration - " + JSON.stringify(conf));
   if(navigator.getUserMedia) {
     navigator.mediaDevices.getUserMedia(conf).then(function(stream){
      cb(null,stream);
     }).catch(function(err){
      cb(err.name||"DetectionFail");
     });
    } else {
     cb(new Error('Your browser does not support getUserMedia API'));
   }
  };
  $rootScope.start_call=function(s) {
   $rootScope.is_audio_call_accepted = true;
   $rootScope.localStream=s;
   EventHandler.WRTC.set_local_stream(s);
   EventHandler.WRTC.set_target($rootScope.conversationID,$rootScope.deviceID);
   EventHandler.WRTC.make_offer($rootScope.accountID,s);
   $timeout(function() {
    $rootScope.$apply();
   },0);
  };
  function showRemoteRunningPopup() {
   // TODO: this is done wrong regardless of digests…
   $rootScope.$applyAsync(function() {
    $rootScope.remote_user_name = $rootScope.remoteConnection.name;
    $('#remote-running-modal').modal();
   });
  }
  $rootScope.onSideMenuItemClick = function(path,nav) {
   if($rootScope.conStatus) showRemoteRunningPopup();
   else $scope.$applyAsync(function() {
    $location.path(path);
    set_nav(nav);
   });
  };
  function prepareSubmitResultEventMessage (content) {
   var et=JSON.parse(content.substring(11)).type;
   if(et==1) return "";
   if(et==2) return $rootScope.strings.str_result_submission_on;
   return $rootScope.strings.str_result_submission_off;
  }
  $rootScope.prepareCallDuration = function(startTime,endTime,callerID){
   var d = endTime-startTime;
   var minutes = "0" + Math.floor(d / 60);
   var seconds = "0" + (d - (minutes * 60));
   var callType = "";
   callType = (callerID == INTERACT.get_myself().id) ? $rootScope.strings.str_outgoing_call : $rootScope.strings.str_incoming_call;
   return callType + (minutes.substr(-2) + ":" + seconds.substr(-2));
  };
  function updateDeviceStatus(did,aid) {
   var devices = INTERACT.get_account(aid).d;
   var dev = devices.find(function(x){return x.id==did});
   INTRACTABLE.request("device/status",
     {"did": did},
     function(e, r) {
      if ((!e) && (r._S == 'ok')) {
       dev.active = r.online;
      }
     });
  }
  $rootScope.awakeDevice = function() {
   $('#btn_wakeupDevice').button('loading');
   INTRACTABLE.request("device/wakeup",
   {
    "did": $rootScope.deviceID
   },
   function(e, r) {
    if(e || r._S!='ok') {
     L.warn({err:e,r:r},"erorr waking up device");
     $('#btn_wakeupDevice').button('reset'); //getting error response when waking up apple devices
     return;
    }
    var attempts=1;
    function getStatus() {
     if(attempts>5) {
      $('#btn_wakeupDevice').button('reset');
      return;
     }
     attempts++;
     INTRACTABLE.request("device/status",
     {
      "did": $rootScope.deviceID
     },
     function(e, r) {
      if((!e) && (r._S=='ok')) {
       if(r.online) {
        L.trace({devid:$rootScope.deviceID},'Device - '+$rootScope.deviceID+" is online now");
        var devices = INTERACT.get_account(+$routeParams.aid).d;
        var dev = devices.find(function(x){return x.id==+$rootScope.deviceID});
        dev.active = true;
        $rootScope.showAwakeButton = false;
        $rootScope.virtualConnection = {};
        sendInitialRequests();
        $('#btn_wakeupDevice').button('reset');
       }
       else setTimeout(getStatus,2000);
      }
     });
    }
    setTimeout(getStatus,3000);
   });
  };
  function sendInitialRequests() {
   var conv=INTERACT.get_conversation($rootScope.conversationID);
   if(!conv.is_alive()||!$rootScope.conversation_is_mine) return;
   if(!$rootScope.isHidden("circle")) {
    EventHandler.startVCforLiveData($rootScope.accountID, $rootScope.deviceID);
    $rootScope.fetch_status();
    EventHandler.APILAYER.sendMessage({
     convid: $rootScope.conversationID,
     channelid: INTERACT.D.xaction.channel.diagreq,
    msg: "8|1",//TODO: magic
    devid: $rootScope.deviceID });
    $rootScope.get_json("tests.tests",TR.setTestsConfiguration);
   }
   if(!$rootScope.isHidden("router-config")) {
    EventHandler.APILAYER.sendMessage({
     convid: $rootScope.conversationID, channelid: INTERACT.D.xaction.channel.diagreq,
     msg: "9|request",// TODO: magic
     devid: $rootScope.deviceID });
   }
   if(!$rootScope.isHidden("speed-test")) {
    $timeout(function() {
     EventHandler.APILAYER.sendMessage({
      convid: $rootScope.conversationID, channelid: INTERACT.D.xaction.channel.diagreq,
      msg: "10|speedtest", // TODO: magic
      devid: $rootScope.deviceID});
    },0);
   }
   if(!$rootScope.isHidden("provider-info")) {
    $timeout(function() {
     EventHandler.APILAYER.sendMessage({
      convid: $rootScope.conversationID, channelid: INTERACT.D.xaction.channel.diagreq,
      msg: "6|publicIP", // TODO: magic
      devid: $rootScope.deviceID });
    },0);
   }
  }
  $rootScope.isDeviceOnline = function() {
   var account = INTERACT.get_account(+$routeParams.aid);
   var selectedDevice = account&&account.d[account.sd];
   return (selectedDevice&&selectedDevice.hasOwnProperty('active')&&selectedDevice.active); 
  };

  var doUpdateDeviceStatus = false;
  var timerUpdatingDeviceStatus;
  $rootScope.stopDeviceStatusCheck = function() {
   if(timerUpdatingDeviceStatus) $timeout.cancel(timerUpdatingDeviceStatus), timerUpdatingDeviceStatus=undefined;
   doUpdateDeviceStatus = false;
  };
  function updateDeviceOnlineStatus(aid,did) {
   doUpdateDeviceStatus = true;
   function reschedule() {
    if(timerUpdatingDeviceStatus) $timeout.cancel(timerUpdatingDeviceStatus), timerUpdatingDeviceStatus=undefined;
    if(doUpdateDeviceStatus) timerUpdatingDeviceStatus=$timeout(updateDeviceOnlineStatus.bind(this,aid,did),20000);
   }
   var devices = INTERACT.get_account(+aid).d;
   var dev = devices.find(function(x){return x.id==+did});
   if(!dev) return L.error({did:did},'device not found in the devices list');
   var oldStatus = dev.active;
   INTRACTABLE.request("device/status",{did:did},function(e, r) {
    if(e) return L.error({err:e},"error updating device online status"),reschedule();
    if(r._S!='ok') return L.error({r:r},"error updating device online status"),reschedule();
    if(oldStatus!=r.online) {
     if(r.online) sendInitialRequests();
     else {
      $rootScope.showProviderInfo=false;
      $rootScope.showTestStatusTable = false;
      updateOrbitCircle({});
      $rootScope.enableLiveResultsControl = false;
      if(!$rootScope.isHidden("h2g-linear-view")) $rootScope.wtg_fixedline.setSummary("","",$rootScope.strings.str_device_offline);
      else $rootScope.orbitX.setStatus("","",$rootScope.strings.str_device_offline);
      if($rootScope.is_in_video_call) $rootScope.$broadcast('video-close');
     }
    }
    dev.active = r.online;
    dev.session_status = r.s;
    if(!$rootScope.isHidden('awake')) $rootScope.showAwakeButton = !r.online;
    if(r.online&&!Object.keys($rootScope.virtualConnection).length) {
     L.trace("device in online - vc broken");
     sendInitialRequests();
    }
    reschedule();
   });
  }

  $rootScope.callStatusHandle = 0;
  $scope.updateCallStatus=function(status, evl){
    $("#call-status-bar").empty();
    $("#call-status-bar").fadeIn("slow").append('<strong>'+status+'</strong>');
    $("#call-status-bar").css("background-color", evl==1?"#749935":"#ff3b00");// TODO: magic
    clearInterval($rootScope.callStatusHandle);
    $rootScope.callStatusHandle = setInterval(function(){$("#call-status-bar").fadeOut("slow")},30000);
  };
  $rootScope.getSessionStatus = function(aid,did,cb) {
   INTRACTABLE.request("device/status",
   {
    "did": did
   },
   function(e, r) {
    if((!e) && (r._S=='ok')) {
     var devices = INTERACT.get_account(+aid).d;
     var dev = devices.find(function(x){return x.id==+did});
     dev.active = r.online;
     dev.session_status = r.s;
     if(!$rootScope.isHidden('awake')) $rootScope.showAwakeButton = !r.online;
     return cb(null,r.s);
    }
    cb(e,r);
   });
  };
  $rootScope.getString = function(id) {
   return $rootScope.strings[id];
  };
  function getTestName(id) {
   return $rootScope.strings.tests[id]||""; // TODO: does empty test name make sense?
  }
  function getGroupName(id) {
   return $rootScope.strings.groups[id]||""; // TODO: does empty group name make sense?
  }
  $rootScope.getEvaluationName = function(id) {
   return $rootScope.strings.evaluations[id]||"";
  };
  function updateResultChange(r) {
   var o = r;
   var dr = tweak_result(JSON.parse(r.tr));
   if(dr.result=="prog") return L.trace({dr:dr},"we don't care to update tests in progress (why?)");
   if(dr.expired&&(excepted_expired_tests[dr.id]||$rootScope.turned_off_tests[dr.id])) return L.warn({dr:dr},"we don't like this test to be expired, it seems");
   if(dr.turn_off) $rootScope.turned_off_tests[dr.id]=true;
   if(!dr.id) return L.warn({dr:dr},"no test id for test result");
   $rootScope.resultGroups = [];
   var account = INTERACT.get_account($rootScope.accountID);
   if(!account) return L.warn({dr:dr},"no account for test result");
   var sd = account.sd;
   if(!account.tr[sd]) account.tr[sd] = {total: 0, results: []};
   var tidn = dr.id;
   account.tr[sd].results.unshift({rid:0,tid:tidn,ts:new Date(),te:INTERACT.D.xaction.result_evaluation[dr.result],tr:dr.details,tc:'',trd:dr.result_data,cid:$rootScope.conversationID});
   ++account.tr[sd].total;
   if($rootScope.diagnose_ticket.id==$rootScope.conversationID) applyResults(account, sd, account.tr[sd].results);
   if(tidn==117&&dr.result=='ok') {
    var trd = JSON.parse(dr.result_data);
    $rootScope.$broadcast("showDeviceLocation",trd.lat,trd.long);
   }
   if(!o.component) return L.trace({dr:dr},"no component for test result");
   TR.updateResult(o,function(e,r){
    updateOrbitCircle(r);
    if($rootScope.current_circle_group == o.component) H2GRESULTS.update(o.component);
    if(!$rootScope.showTraceroute) return;
    setTimeout(function() {
      Object.keys(r.internet).forEach(function(test){
        var t = r.internet[test];
        if((t.test == "wifi_trace_route" || t.test == "mobile_trace_route")){
         TRACEROUTE.draw_traceroute_for_user_ip();
        }
       });
     }, 5);
   });
  }

  if($rootScope.circle_theme!="") loadCircleTheme("circle_theme",$rootScope.circle_theme+"-theme","/h2g-material/css/");
  function loadCircleTheme(id,file,rootpath){
   var styleLink = document.getElementById(id);
   styleLink.setAttribute("href", rootpath + file+".css");
  }

 //load_google_map_api();

 $rootScope.create_MdDialog  = function(inputCtrl,message,template){
   var multiple_popups = message && message.multiple || false;
   $mdDialog.show({
    controller: inputCtrl,
    templateUrl: template,
    parent: angular.element(document.body),
    multiple: multiple_popups,
    locals : {
     message : message
   },
   clickOutsideToClose:false
   });
   // TODO: this "inputDialog" thing that seems to be declared and never used
   // in `h2g-test-results` and made some obscure use of in help2go UI should
   // be eliminated and eradicated.
   inputDialog.restrict=message && message.restrict; // eslint-disable-line no-undef
   inputDialog.hide=$mdDialog.hide.bind($mdDialog);  // eslint-disable-line no-undef
   $scope.$watch(function() {
    return $mdMedia('xs') || $mdMedia('sm');
   }, function(wantsFullScreen) {
    $scope.customFullscreen = (wantsFullScreen === true);
   });
 };
 $rootScope.create_customDialog = function(ctrlName,message,ev){
   var parentEl;
   if(C11N.is_portal) parentEl = angular.element(document.body);
   else{
    parentEl = document.getElementById("mdDialogOverLayScreen");
    parentEl.style.display = "block";
   }
   $mdDialog.show({
    parent: parentEl,
    targetEvent: ev,
    closeDialog:message.busyStateHandle,
    testName:message.testName,
    controller: ctrlName,
    templateUrl: C11N.root_path + 'h2g-material/dialogs/CustomDialog.html',
    clickOutsideToClose:false,
    onRemoving: !C11N.is_portal && dialog_close_event,
    onShowing : !C11N.is_portal && dialog_onShowing_event,
    multiple: false,
    locals: {message : message}
   });
   function dialog_close_event(/*scope, element, options*/) {
    parentEl.style.display = "none";
   }
   function dialog_onShowing_event(/*scope, element, options*/) {
    parentEl.style.display = "block";
   }
 };
 function submitBulkResults(data) {
  var bulk = Object.values(data).reduce(function(p,c) {
   return Object.values(c).reduce(function(p,r) {
    var ecode = INTERACT.D.xaction.result_evaluation[r.result];
    if(ecode===undefined) L.warn({r:r},"invalid evaluation");
    else if(r.row_id) L.warn({r:r},"data already available on the server");
    else {
     r.eval = ecode;
     p.push(r);
    }
    return p;
   },p);
  },[]);
  if(bulk.length) INTRACTABLE.request("test/results/bulk-submit",
   {"DID":$rootScope.deviceID,
    "CID": $rootScope.conversationID,
    "r":bulk},
   function(e, r) {
    if(e) L.error({err:e},"failed to bulk submit results");
    else if(r._S!='ok') L.error({r:r},"failed to bulk submit results");
   });
 }
   $rootScope.show_generic_overlay = function(ctx,message) {
     L.trace({ctx:ctx},"show generic overlay");
     var ctrlName;
     switch(ctx) {
         case 'router_cred_overlay':
              ctrlName = H2GDIALOG.router_cred_overlay_ctrl;
           //TODO: send software usage info for this screen
         break;
         case 'generic_info':
              ctrlName =H2GDIALOG.generic_info_ctrl;
          //TODO: send software usage info for this screen
         break;
         default :
             L.warn('ctx - not found');
             return;
      }
     $mdDialog.show({
      controller: ctrlName,
      templateUrl: C11N.root_path + 'h2g-material/dialogs/GenericOverlay.html',
      locals: {message : message}
     });
  };
   LINEARVIEW.getString = function(id) {
    return $rootScope.getString(id);
   };

  function urlBase64ToUint8Array (base64String) {
   const padding = '='.repeat((4 - base64String.length % 4) % 4);
   const base64 = (base64String + padding)
     .replace(/-/g, '+')
     .replace(/_/g, '/'); // TODO: this replace is beyone me, but it doesn't have much to do with handling base64 and url…

   const rawData = window.atob(base64);
   const outputArray = new Uint8Array(rawData.length);

   for (let i = 0; i < rawData.length; ++i) {
     outputArray[i] = rawData.charCodeAt(i);
   }
   return outputArray;
 }

 if ('serviceWorker' in navigator && 'PushManager' in window) {
  L.trace('Service Worker and Push is supported');
  webpush_supported=true;
  navigator.serviceWorker.register('serviceworker.js')
   .then(function(swReg) {
     L.trace({swreg:swReg},'Service Worker is registered');
   }).catch(function(error) {
     L.error({err:error},"service worker error");
   });
 } else L.warn('Push messaging is not supported');

 if(webpush_supported) {
  Notification.requestPermission().then(function(result) {
   if (result=='denied') {
    L.info("Permission wasn't granted. Allow a retry.");
    return;
   }
   if (result=='default') {
    L.info("The permission request was dismissed.");
    return;
   }
   subscribeUserToPush();
  });
 }

 /* Types of toaster messages {info, success, warning, error}*/
 $rootScope.showToasterMsg = function(msgType, msg, title) {
  var audio = new Audio('audio/notification.mp3');
  if (document.visibilityState == "visible") {
   audio.play();
   toastr.options.closeButton=true;
   toastr[msgType](msg, title);
  }
  else if(webpush_supported && Notification.permission=='granted') {
   navigator.serviceWorker.getRegistration().then(function(reg) {
    audio.play();
    const title = $rootScope.brand_name;
    const options = {
     body: msg,
     icon: $rootScope.notification_icon
    };
    reg.showNotification(title, options);
   });
  }
 };

 function subscribeUserToPush() {
  return navigator.serviceWorker.register('serviceworker.js')
  .then(function(registration) {
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array('BNFTCg9Oi55y113S3UpOw5cS33ccbG-Df8VvwMkTMPs4sgkRqYpnHDbwIKCwy5liUdvB9SyLUBXwhsfQbizmZP0')
    };
   return registration.pushManager.subscribe(subscribeOptions);
  })
  .then(function(pushSubscription) {
    return pushSubscription;
  });
 }
 $rootScope.getTicketTestResults =function(conv) {
   var acid = $rootScope.getAccountID($rootScope.conversationID);
   var account = INTERACT.get_account(acid);
   var sd=account.sd;
   $rootScope.diagnose_ticket=conv;
   var tr = account.tr[sd].results;
   var results = tr.filter(function(x){
    return (x.cid==conv.id);
   });
   if(results.length) return applyResults(account, account.sd, results);
   L.trace({conversation_id:conv.id},'No results found in localdata for this conversation');
   $rootScope.pendingRes.push("results");
   INTRACTABLE.request("test/results",
   {
    "DID": account.d[sd].id,
    'S':'-rid',
    'T':1,
    'L':10,
    'CID':conv.id
   },
   function(e, r) {
    $rootScope.pendingRes.splice($rootScope.pendingRes.indexOf("results"),1);
    if(!$rootScope.pendingRes.length) $('#profileLoadingicon').hide();
    if(e) return L.warn({e:e},"error fetching test results");
    if(r._S!='ok') return L.warn({r:r},"error fetching test results");
    if(!account.tr[sd].results.length) account.tr[sd] = { total: r.total, results: r.results };
    else {
     account.tr[sd].total += r.total;
     account.tr[sd].results=account.tr[sd].results.concat(r.results);
    }
    applyResults(account, sd, r.results);
   });
  };

  $rootScope.checkTerminalAccessPermission = function(did) {
   var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.did==did});
   return tap?tap.grant:false;
  };
  $rootScope.onChangeMessageType = function(message) {
   $scope.$applyAsync(function() {
    $rootScope.selectedMessageType = message;
    var type = message.type;
    var b=!(type==$rootScope.messageTypes[1].type&&!$rootScope.checkTerminalAccessPermission($rootScope.deviceID));
    $rootScope.send_btn_text = b?$rootScope.strings.str_send:$rootScope.strings.str_request_access;
    $rootScope.terminalAccessed = b;
    var tap = $rootScope.terminalAccessPermissions.find(function(x){return x.did==$rootScope.deviceID});
    $rootScope.disable_send_btn = b?false:tap?!tap.btn_disable:false;
   });
  };
  $scope.$on('wtg.interact.results-data', function (evt,args) {
   updateResultChange(args.r);
  });

  $scope.edit_profile = function edit_profile() {
   $mdDialog.show({
    clickOutsideToClose: true,
    templateUrl: 'snippets/dialogs/profile.html',
    scope: $scope.$new(false),
    controllerAs: 'ctrl',
    controller: function($scope,$mdDialog) {
     this.profile = Object.assign({},$rootScope.profile);
     var that = this;
     $scope.pf_submit = function profile_submit() {
      $scope.busybee = true;
      var p = that.profile;
      INTRACTABLE.request("profile",{
       firstname: p.first_name, lastname: p.last_name,
       mobile: p.mobile, email: p.email, preference: 'email'
      },function(e,r) {
       if(e) L.error({err:e},"error updating profile");
       if(r._S!='ok') L.error({r:r},"error updating profile");
       else $rootScope.profile = p;
       $mdDialog.hide('submit');
      });
     };
    }
   });
  };

  $rootScope.show_live_diagnostics_disabled_info = function() {
   var account = INTERACT.get_account($rootScope.accountID);
   var result_submission_val = (account.d[account.sd].result_submission.id == INTERACT.D.xaction.live_diagnostics_states.off);
   if(result_submission_val) {
    H2GDIALOG.showInputTemplate(H2GDIALOG.popupCtrl,{"header" : "",
    "status" : $rootScope.strings.str_diagnostic_results_disabled_desc});
    H2GRESULTS.hideBusyState();
   }
   return result_submission_val;
  };

  $rootScope.speedTestbtnDisable = false;
  $rootScope.runSpeedTest = function() {
   EventHandler.startSpeedTest($rootScope.accountID, $rootScope.deviceID);
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.accountID,
    msg: $rootScope.strings.str_diagnostic_request+$rootScope.strings.speed_test_title,
    msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.diagreq
   });
   $rootScope.speedTestbtnDisable=true;
   $rootScope.speedTestTimeout = $timeout(function() {
    $rootScope.speedtest_error_message = $rootScope.strings.str_speedtest_error_msg;
    $rootScope.speedTestbtnDisable = false;
    speed_test.stop();
    $rootScope.$apply();
    $('#speedtest-fail-modal').modal();
   }, 30000);
  };
  $rootScope.initSpeedtestModule = function(capabilities) {
   SPEEDTESTDATA.capabilities = capabilities;
   $rootScope.loadSpeedTestScreen=true;
  };
  $rootScope.showBusyScreen = function() {};
  $rootScope.hideBusyScreen = function() {};
  TRACEROUTE.perform_traceroute_test = function(test, moredata) {
   L.trace("perform_traceroute_test - "+moredata);
   var testinfo = JSON.parse(moredata);
   if(testinfo&&testinfo.value=="") return;
   var tid= (test=="wifi_trace_route")?134:135;
   EventHandler.APILAYER.sendMessage({
    convid:$rootScope.conversationID, channelid:INTERACT.D.xaction.channel.diagreq,
    msg: '1|'+tid+'|0|'+JSON.stringify({value:testinfo.value,tid:tid}),
    devid: $rootScope.deviceID
   });
  };

  $scope.openNav = () => {
   // TODO: the stuff below belongs to CSS
   $('#mainnav').css('width','220px');
   $('#mainnav-container').css('z-index','1000');
  };
  $scope.closeNav = () => {
   // TODO: the stuff below belongs to CSS
   $("#mainnav").css("width", "0%");
   $("#mainnav-container").css("z-index", "0");
  };
  // TODO: the stuff below is done plainly wrong…
  // but it's better not to mess with it, as there are quite some revamps
  // are coming…
  $('#mainnav-menu').on('click', '.menu-item', function (){
   $("#mainnav").css({"width":"0%", "transition":"width 2s"});
   $("#mainnav-container").css("z-index", "0");
   $('#container').addClass("mainnav-sm");
  });
});
/* vim:set ts=8 sw=1 expandtab: */
